import { UiListCarouselModel } from "../../models";

import { mockCaptionModel } from "./mock-caption";

export function mockUiListCarouselModel({
    id = "list-carousel-1",
    type = "uiListCarousel",
    locale = "en",
    content = mockUiListCarouselModelContent()
}: Partial<UiListCarouselModel> = {}): UiListCarouselModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiListCarouselModelContent = UiListCarouselModel["content"];

export function mockUiListCarouselModelContent({
    title = "Demo list carousel",
    captions = [mockCaptionModel()],
    autoplay = false,
    ...optionals
}: Partial<UiListCarouselModelContent> = {}): UiListCarouselModelContent {
    return {
        title,
        captions,
        autoplay,
        ...optionals
    };
}
